import {WinPresentationController} from "../WinPresentationController";
import {TheRave} from "../../TheRave";

export class NoWinSymbolsController extends WinPresentationController {

    constructor() {
        super("NoWinSymbolsController", false);
    }

    protected hasWin():boolean {
        return (TheRave.model.parsedGameData.betWins.length > 0);
    }

    protected async createWinAnimation(): Promise<void> {
        [0,1,2,3,4].forEach((i:number)=>{
            TheRave.reels[i].reelView.showNoWin(TheRave.model.parsedGameData.currentWinRatioConfig?.normalWinLevel!);
        });
        await Promise.resolve();
    }
}